/**
 * 객체 배열의 특정 프로퍼티 값의 합계
 * @param {*} objArray
 * @param {*} propertyName
 * @returns
 */
export const sumByPropertyName = (objArray, propertyName) => {
  return objArray.reduce((acc, cur) => acc + cur[propertyName], 0)
}

/**
 * ex 0.12 -> 12%
 * @param {*} num
 * @returns
 */
export const toPercentage = (num, toFixed = 1) => {
  return (num * 100).toFixed(toFixed)
}

/**
 * 숫자 select box 생성용
 * @param {*} start
 * @param {*} end
 * @param {*} reverse boolean
 * @returns [start ... end]
 */
export const generateRange = (start, end, reverse) => {
  const range = Array.from({ length: end - start + 1 }, (_, index) => start + index)
  return reverse ? range.reverse() : range
}
